var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container"},[_c('v-progress-circular',{class:_vm.classes,attrs:{"value":_vm.customValue,"size":_vm.size,"width":_vm.width,"color":_vm.color,"indeterminate":_vm.indeterminate,"rotate":_vm.rotate}},[_vm._t("default"),_c('span',{style:(_vm.textStyle)},[_vm._v(" "+_vm._s(_vm.progressPercentage)+" ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }